import { useLayoutEffect, useState } from 'react';
export const useElementHeight = elementRef => {
  const [height, setHeight] = useState(0);
  useLayoutEffect(() => {
    const element = elementRef.current;
    if (!element) {
      return;
    }
    const updateHeight = () => {
      const elementHeight = element.offsetHeight;
      setHeight(elementHeight);
    };
    updateHeight();
    const resizeObserver = new ResizeObserver(() => {
      updateHeight();
    });
    resizeObserver.observe(element);
    return () => {
      resizeObserver.disconnect();
    };
  }, [elementRef]);
  return height;
};